<template>
  <Modal
    :modal="impersonationReasonModalRef"
    :steps="[{ component: ImpersonationReasonModalContent, id: 'impersonation-reason', stepName: null }]"
  />
</template>

<script lang="ts" setup>
import Modal from '@/features/ui/components/modal/modal.vue'
import { selectGetImpersonationReasonModal } from '@/features/ui/store/modal/modal.selectors'
import modalsStore from '@/features/ui/store/modal/modal.store'
import ImpersonationReasonModalContent from './impersonation-reason-modal-content.vue'

const impersonationReasonModalRef = selectGetImpersonationReasonModal(modalsStore)
</script>
